<template>
  <div>
    <div class="mian-box">
      <el-row>
        <el-col>
          <!-- 头部 开始  -->
          <navbar />
          <!-- 头部 结束  -->
          <!-- 主题 开始 -->
          <div ref="keepAliveContainer" class="container-box">
            <keep-alive v-if="is_view">
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
          </div>
          <!-- 主题 结束 -->
        </el-col>
      </el-row>
    </div>

    <!-- 底部 开始  -->
    <Footer />
    <!-- 底部 结束  -->
  </div>
</template>
<script>
import Navbar from './components/Navbar';
import Footer from './components/footer';

export default {
  provide() {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入。
    return {
      reloads: this.reloads
    }
  },
  name: 'Mian',
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      is_view: true
    }
  },

  beforeCreate() {
    console.log('beforeCreate')
  },
  mounted() {

  },
  created() {
    let that = this;
    let getViewportSize = this.$getViewportSize();
    this.parentH = getViewportSize.height;
    this.parentW = getViewportSize.width;
  },
  beforeDestroy() {
    //断开连接

  },
  methods: {
    setsickNess() {
      this.is_view = false;
      console.log(this.is_view)
      this.$nextTick(() => {
        this.is_view = true
        console.log(this.is_view)
      })

    },
  },

}
</script>
<style lang="scss" scoped>
.mian-box {
  max-width: 1400px;
  min-height: 100%;
  margin: 0 auto;
  // padding-bottom: 75px;
}

.container-box {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  min-height: 100%;
  flex: 1;
  padding-bottom: 10px;

  .container {
    margin: 20px auto 0;
  }
}

@media (min-width: 1400px){
  #headbar {
    width: 1400px;
  }
}
@media (max-width: 1380px){
  #headbar {
    width: 1200px;
  }
  .mbx {
    margin: 0 20px;
  }
}
</style>